import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_search_box = _resolveComponent("g-search-box");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_g_search_box, {
                mode: _ctx.dataLoadMode,
                "id-field": _ctx.idField,
                "key-field": _ctx.keyField,
                "parent-field": _ctx.parentField,
                "label-field": _ctx.labelField,
                "icon-field": _ctx.iconField,
                "dropdown-mode": _ctx.dropdownMode,
                "drop-down-height": _ctx.dropDownHeight,
                "select-leaf-only": _ctx.selectLeafOnly,
                "data-store": _ctx.dataStore,
                "data-adapter": _ctx.dataAdapter,
                "data-args": _ctx.dataArgs,
                columns: _ctx.columns,
                "page-size": _ctx.pageSize,
                readonly: _ctx.readOnly,
                placeholder: _ctx.placeholder,
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
            }, null, 8, ["mode", "id-field", "key-field", "parent-field", "label-field", "icon-field", "dropdown-mode", "drop-down-height", "select-leaf-only", "data-store", "data-adapter", "data-args", "columns", "page-size", "readonly", "placeholder", "modelValue"])
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
